import React from "react";
import classnames from "classnames";

import { SelectOption } from "@vahak/core-ui/dist/components/Select";
import LocationPinOutlined from "@vahak/core/dist/standard-icons/location-pin-outlined.svg";
import LocationArrow from "@vahak/core/dist/standard-icons/location-arrow.svg";
import ArrowRightWhite from "@vahak/core/dist/icons/arrow-right-white.svg";

import Styles from "./MarketplaceLoadFilterCard.module.scss";
import MarketplaceFilterStateSingleField, {
    MarketplaceFilterFieldFocusHandle
} from "./filter-fields/MarketplaceFilterStateSingleField";
import MarketplaceFilterStateMultiField from "./filter-fields/MarketplaceFilterStateMultiField";
import MarketplaceFilterLorryTypeField from "./filter-fields/MarketplaceFilterLorryTypeField";

export interface MarketplaceLoadFilterCardProps {
    eyebrow: string;
    fromPlaceholder: string;
    toPlaceholder: string;
    lorryTypePlaceholder: string;
    searchLabel: string;
    clearFiltersLabel: string;
    hasActiveFilters?: boolean;
    srcState?: SelectOption<number>;
    destStates?: SelectOption<number>[];
    lorryTypeIds?: number[];
    showLorryType?: boolean;
    srcFieldRef?: React.RefObject<MarketplaceFilterFieldFocusHandle>;
    onSrcChange: (value?: SelectOption<number>) => void;
    onDestChange: (value?: SelectOption<number>[]) => void;
    onLorryTypeChange: (lorryTypeIds: number[]) => void;
    onSearch: () => void;
    onClearFilters: () => void;
    className?: string;
}

const MarketplaceLoadFilterCard = ({
    eyebrow,
    fromPlaceholder,
    toPlaceholder,
    lorryTypePlaceholder,
    searchLabel,
    clearFiltersLabel,
    hasActiveFilters = false,
    srcState,
    destStates = [],
    lorryTypeIds = [],
    showLorryType = true,
    srcFieldRef,
    onSrcChange,
    onDestChange,
    onLorryTypeChange,
    onSearch,
    onClearFilters,
    className
}: MarketplaceLoadFilterCardProps) => {
    return (
        <div className={classnames(Styles.card, className)}>
            <p className={Styles.eyebrow}>{eyebrow}</p>

            <div className={Styles.filtersRow}>
                <div className={classnames(Styles.row, Styles.rowLocations, Styles.routeGroup)}>
                    <MarketplaceFilterStateSingleField
                        ref={srcFieldRef}
                        id="marketplace-filter-src"
                        placeholder={fromPlaceholder}
                        mobileTitle={fromPlaceholder}
                        icon={<LocationPinOutlined className={Styles.fieldIconPin} aria-hidden />}
                        value={srcState}
                        onChange={onSrcChange}
                    />

                    <MarketplaceFilterStateMultiField
                        id="marketplace-filter-dest"
                        placeholder={toPlaceholder}
                        mobileTitle={toPlaceholder}
                        icon={<LocationArrow className={Styles.fieldIcon} aria-hidden />}
                        value={destStates}
                        onChange={onDestChange}
                    />
                </div>

                {showLorryType ? (
                    <div className={Styles.lorryField}>
                        <MarketplaceFilterLorryTypeField
                            placeholder={lorryTypePlaceholder}
                            mobileTitle={lorryTypePlaceholder}
                            value={lorryTypeIds}
                            onChange={onLorryTypeChange}
                        />
                    </div>
                ) : null}
            </div>

            <div className={Styles.actionsRow}>
                <button type="button" className={Styles.searchBtn} onClick={onSearch} disabled={!srcState}>
                    <span>{searchLabel}</span>
                    <ArrowRightWhite className={Styles.searchBtnIcon} aria-hidden />
                </button>
                <button type="button" className={Styles.clearBtn} onClick={onClearFilters} disabled={!hasActiveFilters}>
                    {clearFiltersLabel}
                </button>
            </div>
        </div>
    );
};

export default MarketplaceLoadFilterCard;
